import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import App from './App.vue'
import router from './router'
import store from './store'
import { initRem } from '@/utils/setRem'
import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import '@/styles/iconfont/iconfont.css'

initRem()

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

store.dispatch('user/init')

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
